import React from 'react'
import styled, { css } from 'styled-components/macro'
import { defaultSeoImage } from 'services/constants'
import PropTypes from 'prop-types'
import { Clamp } from 'components/atoms';

const FacebookShare = ({
  title,
  description,
  url,
  withDescription,
  src,
  isLoading,
}) => (
  <Share withDescription={withDescription} src={src}>
    {src && (
      <Share.Image
        image={isLoading ? null : src}
        withDescription={withDescription}
      />
    )}
    <Share.Data>
      <Share.Data.Url>
        {isLoading ? '' : url}
      </Share.Data.Url>
      <Share.Data.Title>
        {isLoading ? '' : title || 'Por favor escreva um título...'}
      </Share.Data.Title>
      {withDescription && (
        <Share.Data.Description>
          <Clamp lines={2}>
            {isLoading ? '' : description || 'Por favor escreva uma descrição...'}
          </Clamp>
        </Share.Data.Description>
      )}
    </Share.Data>
  </Share>
)

FacebookShare.propTypes = {
  withDescription: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string,
  src: PropTypes.string,
  isLoading: PropTypes.bool,
}

FacebookShare.defaultProps = {
  withDescription: false,
  title: null,
  description: null,
  url: 'ua.pt',
  src: defaultSeoImage,
  isLoading: false,
}

const Share = styled.div`
  ${props => (props.withDescription
    ? css`
      display: grid;
      grid-template-columns: ${props.src ? '110px 1fr' : '1fr'};
      grid-template-rows: 110px;
      grid-column-gap: 0px;
      grid-row-gap: 0px;
      overflow: hidden;
  `
    : css`
      display: flex;
      flex-direction: column;
  `)
}

`

Share.Image = styled.div`
  width: 100%;
  height: 100%;
  background-color: #c7cbd4;
  border: 1px solid #CCCCD2;
  display: flex;
  align-items: center;
  justify-content: center;
  ${props => props.image && (props.withDescription
    ? css`
    background-image: url(${props => props.image});
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: center;
    padding-bottom: 52.188%;
    `
    : css`
    background-image: url(${props => props.image});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    min-height: 300px;
    `
  )
}
`

Share.Data = styled.div`
  width: 100%;
  height: 100%;
  background: #f2f3f5 0% 0% no-repeat padding-box;
  padding: 6px 12px;
`

Share.Data.Url = styled.div`
  color: #606770;
  flex-shrink: 0;
  font-size: 12px;
  line-height: 16px;
  overflow: hidden;
  padding: 0;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
`

Share.Data.Title = styled.div`
  color: #1d2129;
  font-weight: 600;
  overflow: hidden;
  font-family: inherit;
  font-size: 16px;
  line-height: 20px;
  margin: 3px 0 0;
  padding-top: 2px;
  letter-spacing: normal;
`

Share.Data.Description = styled.div`
  color: #606770;
  font-size: 13px;
  line-height: 20px;
  word-break: break-word;
  padding-top: 4px;
`

export default FacebookShare
